"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const camelcaseKeys = require("camelcase-keys");
const Country_1 = require("./Country");
class City extends Country_1.default {
    constructor(response) {
        super(response);
        const camelcaseResponse = camelcaseKeys(response, {
            deep: true,
            exclude: [/\-/],
        });
        this.city = camelcaseResponse.city || undefined;
        this.location = camelcaseResponse.location || undefined;
        this.postal = camelcaseResponse.postal || undefined;
        this.subdivisions = camelcaseResponse.subdivisions || undefined;
    }
}
exports.default = City;
